const SCOPE = 'app/navigation/';
export const ActionTypes = {
    OPEN_NAVIGATION: `${SCOPE}OPEN_NAVIGATION`,
    CLOSE_NAVIGATION: `${SCOPE}CLOSE_NAVIGATION`,
};

export const openNavigation = () => ({ type: ActionTypes.OPEN_NAVIGATION });
export const closeNavigation = () => ({ type: ActionTypes.CLOSE_NAVIGATION });
